import { render, staticRenderFns } from "./PaymentView.vue?vue&type=template&id=10585d8b&scoped=true"
import script from "./PaymentView.vue?vue&type=script&lang=js"
export * from "./PaymentView.vue?vue&type=script&lang=js"
import style0 from "./PaymentView.vue?vue&type=style&index=0&id=10585d8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10585d8b",
  null
  
)

export default component.exports